(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["ambassadors-main"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {

    $('.ambassadors-main .-faqs .-block .-title').click(function(){
      $(this).toggleClass('-active');
    	$(this).next().slideToggle();
    });
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-main"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {

  $('.faq-main .-title').click(function(){
    $(this).toggleClass('-active');
  	$(this).next().slideToggle();
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"]) return;
  try {
    
$('.custom-home-banner .-container').slick({
    infinite: true,
	autoplay: true,
	autoplaySpeed: 3500,
	pauseOnHover: true,
    centerMode: true,
    speed: 800,
    variableWidth: true,
    arrows: true,
    prevArrow: '.custom-home-banner .-prev',
    nextArrow: '.custom-home-banner .-next',
    dots: true,
	appendDots: '.custom-home-banner .-dots'
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-popular-flavors"]) return;
  try {
    
  $('.custom-popular-flavors .-container.mobile-only').slick({
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    appendDots: '.custom-popular-flavors .-dots'
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-quotes"]) return;
  try {
    
$('.custom-quotes .-quotes').slick({
  infinite: true,
  arrows: true,
  dots: false,
  prevArrow: '.custom-quotes .-prev',
  nextArrow: '.custom-quotes .-next'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-discover-yerbae"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var context = $('.landing-discover-yerbae .-mid');
  $('.product-selection', context).change(function() {
      $('.landing-discover-yerbae .btn').attr('href', '#');
      switch ($(this).val()) {
          case 'flex':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/flex.jpg?v=1620762800');
              $('.-right .-desc', context).text('Try out our variety pack featuring 3 deliciously fruity naturally caffeinated energy flavors - Watermelon Strawberry, Orange Vanilla, and Mango Passionfruit.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772209356959');
            $('.landing-discover-yerbae .btn').attr('sz-plan','63504543');
            break;
          case 'power':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/power.jpg?v=1620762800');
              $('.-right .-desc', context).text('Try out our variety pack featuring 3 deliciously fruity naturally caffeinated energy flavors - Gourmet Grape, Iced Triple Berry and Black Cherry Pineapple.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772211585183');
            $('.landing-discover-yerbae .btn').attr('sz-plan','63602847');
            break;
          case 'black':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Black_Cherry.jpg?v=1644271771');
              $('.-right .-desc', context).html('Beautiful black cherry tartness meets a tropical squeeze of pineapple in this perky naturally caffeinated energy with yerba mate.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772136939679');
            $('.landing-discover-yerbae .btn').attr('sz-plan','62226591');
            break;
          case 'gourmet':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Gourmet_Grape.jpg?v=1644271716');
              $('.-right .-desc', context).html('Our Gourmet Grape naturally caffeinated energy is a grown-up upgrade from your schoolyard days, with tingly carbonation and plenty of natural energy to power you past your midday slump.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772140642463');
            $('.landing-discover-yerbae .btn').attr('sz-plan','62324895');
            break;
          case 'iced':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Iced_Triple_Berry.jpg?v=1644271716');
              $('.-right .-desc', context).html('This bevvy of berries in this sparkling water energy is delightfully sweet, with the hint of tartness that makes berries so irresistible.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772148998303');
            $('.landing-discover-yerbae .btn').attr('sz-plan','62423199');
            break;
          case 'mango':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Mango_Passion_Fruit.jpg?v=1644271716');
              $('.-right .-desc', context).html('Mango Passion Fruit naturally caffeinated energy with yerba mate is a flavor combo that is sure to feel like a summers day by the water.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772160794783');
            $('.landing-discover-yerbae .btn').attr('sz-plan','62521503');
            break;
          case 'orange':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Orange_Vanilla.jpg?v=1644271716');
              $('.-right .-desc', context).html('Inspired by a flavor favorite, Orange Vanilla naturally caffeinated energy with yerba mate is a delightful mixture of sunny tang and mellow satisfaction!');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772182061215');
            $('.landing-discover-yerbae .btn').attr('sz-plan','62718111');
            break;
          case 'strawberry':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Strawberry_Blonde.jpg?v=1644271717');
              $('.-right .-desc', context).html('Berry picking without the work. Enjoy a blast of juicy strawberry flavor in this naturally caffeinated energy with the subtle addition of tea and the brightness of the bubbles.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772195135647');
            $('.landing-discover-yerbae .btn').attr('sz-plan','63013023');
            break;
          case 'watermelon':
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Watermelon_Strawberry.jpg?v=1644271716');
              $('.-right .-desc', context).html('Watermelon Strawberry naturally caffeinated energy with yerba mate combines these two deliciously juicy fruits for satisfying hydration.');
              $('.landing-discover-yerbae .btn').attr('sz-add','37772203327647');
            $('.landing-discover-yerbae .btn').attr('sz-plan','63209631');
            break;
          default:
              $('.-left > img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/16oz_lineup.jpg?v=1644277076');
              $('.-right .-desc', context).text('16oz Yerbaé is a sweetened natural energy boost with organic stevia, featuring a bolder flavor and 160mg of plant-based caffeine to help you recharge and tackle any challenge.');
            $('.landing-discover-yerbae .btn').removeAttr('sz-add');
            $('.landing-discover-yerbae .btn').removeAttr('sz-plan');
            $('.landing-discover-yerbae .btn').removeAttr('href');
      }
  });
  
  $('.landing-discover-yerbae .btn').click(function(e) {
    e.preventDefault();
    if ($(this).attr('sz-add').length > 0) {
      $('.landing-discover-yerbae .btn').text('ADDING TO CART...');
      $('.landing-discover-yerbae .btn').removeAttr('href');
      setTimeout(function(){
      window.location="/checkout/?discount=TRY4FREE";
      }, 500);
    }
    return false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-faire-signup"]) return;
  try {
    
  function getQS(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
document.addEventListener("DOMContentLoaded", function() {

  var utmc = getQS('utm_campaign');
  var utmm = getQS('utm_medium');
  var utms = getQS('utm_source');

  if (utmc) $('[name="utm_campaign"]').val(utmc);
  if (utmm) $('[name="utm_medium"]').val(utmm);
  if (utms) $('[name="utm_source"]').val(utms);


  $('.landing-faire-signup form').submit(function(e){
    e.preventDefault();
    var data = new FormData();    
    $('.landing-faire-signup form [type=submit]', this).css('cursor', 'progress');
    var formdata = new FormData(this);
    jQuery.ajax({
        url: 'https://api.yerbae.com/faireform/',
        data: formdata,
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
        type: 'POST',
        success: function(data){
          if (!data.success) {
            $('.landing-faire-signup form ._error').text(data.message);
            $('.landing-faire-signup form [type=submit]').removeProp('disabled');
            $('.landing-faire-signup form [type=submit]').css('cursor', 'pointer'); 
          } else {
            $('.landing-faire-signup form').html("<br/><br/><h4>Thank you!</h4><h5>Forwarding to Faire Signup ... </h5>");
            try { 
              fbq('track', 'Lead'); 
            } catch (e) {
              console.log('caught');
              console.log(e);
            }            
            var url = "https://yerbae.faire.com/user/sign-up?signUp=1&email="+formdata.get('Email')
            $(location).prop('href', url);
          }
        }
    });
    
    return;
  });
});
(function(d,s){var DID="635802af-a1ae-4afd-bf38-309cffcffc98";var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);js.async=1;js.src="https://track.cbdatatracker.com/Home?v=3&id='"+DID+"'";fjs.parentNode.insertBefore(js,fjs);}(document,'script'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-sampler-pack"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {

$('.landing-sampler-pack .btn').click(function(e) {
  e.preventDefault();
  $('.landing-sampler-pack .btn').text('ADDING TO CART...');
  $('.landing-sampler-pack .btn').removeAttr('href');
  setTimeout(function(){
    window.location="/checkout/?discount=FREESAMPLER";
  }, 500);
  return false;
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-summer-flavors"]) return;
  try {
    
  $('.-variants select').change(function() {
      window.location.href= "/products/" + $(this).val() + "?summer=1";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-try-a-case-on-us"]) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function() {
     let context = $('.landing-try-a-case-on-us .-mid');
     $('.-left .product-selection', context).change(function() {
         $('.-left .btn', context).attr('href', '#');
         switch ($(this).val()) {
             case 'flex':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/flex.jpg?v=1620762800');
                 $('.-left .-desc', context).text('Try out our variety pack featuring 3 deliciously fruity naturally caffeinated energy beverage flavors - Watermelon Strawberry, Orange Vanilla, and Mango Passionfruit.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '40125112483999');
                 break;
             case 'power':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/power.jpg?v=1620762800');
                 $('.-left .-desc', context).text('Try out our variety pack featuring 3 deliciously fruity naturally caffeinated energy beverage flavors - Gourmet Grape, Iced Triple Berry and Black Cherry Pineapple.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '40125111992479');
                 break;
             case 'black':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Black_Cherry.jpg?v=1644271771');
                 $('.-left .-desc', context).html('Beautiful black cherry tartness meets a tropical squeeze of pineapple in this perky naturally caffeinated energy beverage with yerba mate.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409320579297');
                 break;
             case 'gourmet':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Gourmet_Grape.jpg?v=1644271716');
                 $('.-left .-desc', context).html('Our Gourmet Grape naturally caffeinated energy beverage is a grown-up upgrade from your schoolyard days, with tingly carbonation and plenty of natural energy to power you past your midday slump.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409322610913');
                 break;
             case 'iced':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Iced_Triple_Berry.jpg?v=1644271716');
                 $('.-left .-desc', context).html('This bevvy of berries in this sparkling water energy beverage is delightfully sweet, with the hint of tartness that makes berries so irresistible.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409324740833');
                 break;
             case 'mango':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Mango_Passion_Fruit.jpg?v=1644271716');
                 $('.-left .-desc', context).html('Mango Passion Fruit naturally caffeinated energy beverage with yerba mate is a flavor combo that is sure to feel like a summers day by the water.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409326248161');
                 break;
             case 'orange':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Orange_Vanilla.jpg?v=1644271716');
                 $('.-left .-desc', context).html('Inspired by a flavor favorite, Orange Vanilla naturally caffeinated energy beverage with yerba mate is a delightful mixture of sunny tang and mellow satisfaction!');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409328935137');
                 break;
             case 'strawberry':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Strawberry_Blonde.jpg?v=1644271717');
                 $('.-right .-desc', context).html('Berry picking without the work. Enjoy a blast of juicy strawberry flavor in this naturally caffeinated energy beverage with the subtle addition of tea and the brightness of the bubbles.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409329983713');
                 break;
             case 'watermelon':
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Watermelon_Strawberry.jpg?v=1644271716');
                 $('.-left .-desc', context).html('Watermelon Strawberry naturally caffeinated energy beverage with yerba mate combines these two deliciously juicy fruits for satisfying hydration.');
                 $('.landing-try-a-case-on-us .-left .btn').attr('sz-add', '42409331327201');
                 break;
             default:
                 $('.-left img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/16oz_lineup.jpg?v=1644277076');
                 $('.-left .-desc', context).text('16oz Yerbaé is a sweetened natural energy boost with organic stevia, featuring a bolder flavor and 160mg of plant-based caffeine to help you recharge and tackle any challenge.');
                 $('.landing-try-a-case-on-us .-left .btn').removeAttr('sz-add');
                 $('.landing-try-a-case-on-us .-left .btn').removeAttr('href');
         }
     });

     $('.landing-try-a-case-on-us .-left .btn').click(function(e) {
         e.preventDefault();
         if ($(this).attr('sz-add').length > 0) {
             $('.landing-try-a-case-on-us .-left .btn').text('ADDING TO CART...');
             $('.landing-try-a-case-on-us .-left .btn').removeAttr('href');
             setTimeout(function() {
                 window.location = "/checkout/?discount=FREETASTE16";
             }, 500);
         }
         return false;
     });

     $('.-right .product-selection', context).change(function() {
         $('.landing-try-a-case-on-us .-right .btn').attr('href', '#');
         switch ($(this).val()) {
             case 'performance':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/crossfit-pack-perform.jpg?v=1620750553');
                 $('.-right .-desc', context).text('Can’t pick one? Try out our variety pack featuring 3 deliciously fruity <span data-mce-fragment=&quot;1&quot;>naturally caffeinated sparkling water&nbsp;</span>flavors - Acai Blueberry, Orange Cherry Pineapple, and Pomegranate Berry.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '40125112746143');
                 break;
             case 'tropical':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/crossfit-pack-tropical.jpg?v=1620750553');
                 $('.-right .-desc', context).text('Can’t pick one? Try out our variety pack featuring 3 deliciously fruity <span data-mce-fragment=&quot;1&quot;>naturally caffeinated sparkling water&nbsp;</span>flavors - Acai Blueberry, Strawberry Kiwi and Pineapple Coconut.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '40125112615071');
                 break;
             case 'acai':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Acai_Blueberry.jpg?v=1644271397');
                 $('.-right .-desc', context).html('A plant-based, naturally caffeinated sparkling water that will fuel your day and keep you ready for anything that comes your way.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '42409301803233');
                 break;
             case 'orange':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Orange_Cherry_Pineapple.jpg?v=1644271397');
                 $('.-right .-desc', context).html('Orange Cherry Pineapple naturally caffeinated sparkling water with yerba mate combines three deliciously juicy fruits for satisfying hydration.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '42409310650593');
                 break;
             case 'pineapple':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Pineapple_Coconut.jpg?v=1644271397');
                 $('.-right .-desc', context).html('Pineapple Coconut naturally caffeinated sparkling water with yerba mate brings your favorite tropical flavor mix into a fresh, naturally delicious drink. Refresh your day with this timeless tropical combo.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '42409313206497');
                 break;
             case 'pomegranate':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Pomegranate_Berry.jpg?v=1644271397');
                 $('.-right .-desc', context).html('The tartness of the pomegranate and the earthiness of the tea blend in this naturally caffeinated sparkling water will help you feel grounded in the midst of your demanding schedule.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '42409315696865');
                 break;
             case 'strawberry':
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/Strawberry_Kiwi.jpg?v=1644271398');
                 $('.-right .-desc', context).html('Recharge with our West Coast style naturally caffeinated sparkling water blend of Strawberry Kiwi Sparkling yerba mate.');
                 $('.landing-try-a-case-on-us .-right .btn').attr('sz-add', '42409318056161');
                 break;
             default:
                 $('.-right img', context).attr('src', 'https://cdn.shopify.com/s/files/1/0363/3620/5959/files/12oz_lineup.jpg?v=1644277173');
                 $('.-right .-desc', context).text('12oz Yerbaé is unsweetened naturally caffeinated sparkling water featuring a lighter, subtle hint of flavor with 100mg of plant-based caffeine to refresh with the perfect boost of energy.');
                 $('.landing-try-a-case-on-us .-right .btn').removeAttr('sz-add');
                 $('.landing-try-a-case-on-us .-right .btn').removeAttr('href');
         }
     });

     $('.landing-try-a-case-on-us .-mid .-right .btn').click(function(e) {
         e.preventDefault();
         if ($(this).attr('sz-add').length > 0) {
             $('.landing-try-a-case-on-us .-right .btn').text('ADDING TO CART...');
             $('.landing-try-a-case-on-us .-right .btn').removeAttr('href');
             setTimeout(function() {
                 window.location = "/checkout/?discount=FREETASTE12";
             }, 500);
         }
         return false;
     });
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
      
$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
  
$(window).on('resize scroll', function() {
  if ($('#template-product .product-main .-purchase .-add .btn').isInViewport()) {
    $('#template-product .add-floater').css('bottom', '-155px');
  } else {
    $('#template-product .add-floater').css('bottom', '0px');
  }
});
  
$('#template-product .add-floater .btn').click(function(){
  $('#template-product .add-floater').css('bottom', '-155px');
  $('#template-product .add-floater').css('opacity', '0');
  setTimeout(function(){
    $('#template-product .add-floater').css('display', 'none');
  }, 250);
});
  
$('.custom-subscribe-callout .btn').click(function(e){
  e.preventDefault();
  $('.-freq .-option').first().click();
  $('.-add .btn').click();
  return false;
});

$('.product-main .-images-mobile .-product-slider-top').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.product-main .-images-mobile .-product-slider-nav'
});
$('.product-main .-images-mobile .-product-slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.product-main .-images-mobile .-product-slider-top',
  arrows: false,
  dots: false,
  focusOnSelect: true,
  adaptiveHeight: true
});

let subTimer = setInterval(function(){
  if ($('.-freq .-option').is(":visible")) {
    $('.-freq .-option').first().click();
    clearInterval(subTimer);
  }
}, 500);
  
$('.product-gallery .-product-slider-nav').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    }
  ]
});

$('[data-fancybox]').fancybox({
  clickContent: false
});

$('.-quantity .-minus').click(function(){
	let currentVal = parseInt($('.-quantity input').val());
	if (currentVal > 1) {
		$('.-quantity input').val(currentVal - 1);
		$('.product-main .btn[sz-add]').attr('sz-qty', currentVal -1);
        $('.add-floater .btn[sz-add]').attr('sz-qty', currentVal -1);
	}
});

$('.-quantity .-plus').click(function(){
	let currentVal = parseInt($('.-quantity input').val());
	$('.-quantity input').val(currentVal + 1);
	$('.product-main .btn[sz-add]').attr('sz-qty', currentVal + 1);
    $('.add-floater .btn[sz-add]').attr('sz-qty', currentVal + 1);
});

$('.-quantity input').change(function(){
	$('.product-main .btn[sz-add]').attr('sz-qty', $(this).val());
	$('.add-floater .btn[sz-add]').attr('sz-qty', $(this).val());
});

$('.opinew-no-reviews-stars-plugin b').text($('.opinew-no-reviews-stars-plugin b').text().trim().replace('(','').replace(')',' reviews'));

//Review plugin edits
$(document).ready(function(){
  setTimeout(function(){
      $('#opinew-reviews-product-page-code').prepend('<h1>CUSTOMER REVIEWS</h1>');
      $('#opinew-reviews-product-page-code').parent().parent().parent().addClass('product-reviews');
      $('.summary-card-container .opw-px-2').slick({
        dots: false,
        arrows: true,
		prevArrow: '<button type="button" class="slick-prev">❮</button>',
		nextArrow: '<button type="button" class="slick-next">❯</button>',
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        adaptiveHeight: true,
		responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
      }]
      });
  }, 500);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
          if (html.querySelector('.grid__item')) this.classList.add('product-recommendations--loaded');
        })
        .catch(e => {});
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);
  $(document).ready(function(){
	setTimeout(function(){
      $('.product-recommendations .-recs.mobile-only').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
      });
	}, 750);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-main"]) return;
  try {
    
  // $('[data-title="variety refresh pack"').insertAfter($('[data-title="variety tropical pack"]'));

  // Filter functionality
  $('.-filter span').click(function(){
    let cx = $('.-products');
    $('.-filter span').removeClass('-selected');
    $(this).addClass('-selected');
    // $('.banner img').hide();
    if ($(this).hasClass("-beverage")) {
      $('.-prod', cx).not('[data-type="Energy Beverage"]').hide();
      $('.-prod[data-type="Energy Beverage"]', cx).show();
      // $('.banner .banner-beverage', cx).show();
    } else if ($(this).hasClass("-seltzer")) {
      $('.-prod', cx).not('[data-type="Energy Seltzer"]').hide();
      $('.-prod[data-type="Energy Seltzer"]').show();
      // $('.banner .banner-seltzer', cx).show();
    } else if ($(this).hasClass("-merch")) {
      $('.-prod', cx).not('[data-type="Merch"]').hide();
      $('.-prod[data-type="Merch"]').show();
      // $('.banner .banner-seltzer', cx).show();
    } else {
      $('.-prod', cx).show();
      // $('.banner .banner-generic').show();
    } 
  });
  

  //on /?filter={beverage/seltzer} in URL, load appropriate filter
  let qp = queryParam('filter');
  switch (qp) {
    case 'beverage':
    	$('.-filter span.-beverage').click();
    	break;
    case 'seltzer':
    	$('.-filter span.-seltzer').click();
    	break;
    case 'merch':
    	$('.-filter span.-merch').click();
    	break;
  }

  $(".-prod[data-variety=1]").each(function(i, obj){
    $(this).appendTo('.-products');  
  });
  $(".-prod[data-type=Merch]").each(function(i, obj){
    $(this).appendTo('.-products');  
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-variety-packs"]) return;
  try {
    
  $('.custom-popular-flavors .-container.mobile-only').slick({
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    appendDots: '.custom-popular-flavors .-dots'
  });

  } catch(e) { console.error(e); }
})();

})();
